import RenewalOrderConfirmReceptModal from './renewal-order-confirm-recept-modal.vue'
export default RenewalOrderConfirmReceptModal
